import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 8,
    borderRadius: 16,
    marginTop: 8,
    border: 0,
  },
  title: {
    width: '80%',
    marginBottom: 8,
    alignSelf: 'center',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontWeight: 700,
    fontSize: 18,
  },
}));
